import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class CdnService {
  constructor(private http: HttpClient) { }

  getStateLists(): Observable<any> {
    var url = `${environment.masterCdnBaseUri}statemaster.json`;
    return this.http.get(url, { observe: 'response' }).pipe(
      map((response: any) => {
        return response.body;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  getDistrictLists(stateId: any): Observable<any> {
    // console.log('distrctlistcalled')
    let stateidLenth = stateId < 10 ? `0${stateId}` : stateId;
    var url = `${environment.masterCdnBaseUri}state/${stateidLenth}.json`;

    return this.http.get(url, { observe: 'response' }).pipe(
      map((response: any) => {
        return response.body;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  getBlockLists(stateId: any, districtId: any): Observable<any> {
    // console.log('blocklistcalled')
    let stateidLenth = stateId < 10 ? `0${stateId}` : stateId;
    var url = `${environment.masterCdnBaseUri}state/${stateidLenth}/district/${districtId}.json`;

    return this.http.get(url, { observe: 'response' }).pipe(
      map((response: any) => {
        return response.body;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  //get all panchayat
  getPanchayatLists(stateId: any, districtId: any, blockId: any): Observable<any> {
    // console.log('panchayatlistcalled')
    let stateidLenth = stateId < 10 ? `0${stateId}` : stateId;
    var url = `${environment.masterCdnBaseUri}state/${stateidLenth}/district/${districtId}/block/${blockId}.json`;
    return this.http.get(url, { observe: 'response' }).pipe(
      map((response: any) => {
        return response.body;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  getVillageLists(stateId: any, districtId: any, blockId: any, panchayatId: any): Observable<any> {
    // console.log('villagelistcalled')
    let stateidLenth = stateId < 10 ? `0${stateId}` : stateId;
    var url = `${environment.masterCdnBaseUri}state/${stateidLenth}/district/${districtId}/block/${blockId}/panchayat/${panchayatId}.json`;

    return this.http.get(url, { observe: 'response' }).pipe(
      map((response: any) => {
        response.body = response.body.map((village: any) => {
          return { ...village, panchayat_id: panchayatId };
        });
        return response.body;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  getUserInfo() {
    let url = `${environment.keycloak.issuer}/realms/${environment.keycloak.realm}/protocol/openid-connect/userinfo`;
    return this.http.get(url, { observe: 'response' }).pipe(
      map((response: any) => {
        return response.body;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  //get thimatic api
  getThematicData() {
    let url = `${environment.masterCdnUri}cadre/master/cadre-master-thematic.json`;
    return this.http.get(url, { observe: 'response' }).pipe(
      map((response: any) => {
        // console.log('thematic data2')
        return response.body;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
  // https://cdn.lokos.in/cadre/master/cadre-master-thematic-role.json
  //get role thimatic api
  getRoleThematicData() {
    let url = `${environment.masterCdnUri}cadre/master/cadre-master-thematic-role.json`;
    return this.http.get(url, { observe: 'response' }).pipe(
      map((response: any) => {
        // console.log('thematic data')
        return response.body;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
}
